import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  viewSwitcher: {
    marginBottom: '40px'
  },
  billsActions: {
    marginTop: '18px',
    display: 'flex',
    alignItems: 'center',
    '& .MuiToggleButtonGroup-root': {
      marginRight: '10px'
    }
  },
  providerActions: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiButton-root': {
      marginLeft: '10px'
    }
  },
  pageFooter: {
    marginTop: '40px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  provider: {
    marginTop: '40px',
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: '2px',
    padding: '24px 40px 40px 40px'
  },
  providerTitle: {
    margin: '-24px -40px 0 -40px',
    padding: '24px 40px',
    background: palette.brandGradients.fade,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  billingItem: {
    backgroundColor: palette.shades[200],
    borderRadius: '2px',
    padding: '12px 18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '4px',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  billingItemHeader: {
    borderBottom: "2px solid ".concat(palette.shades[400])
  },
  billingTable: {
    borderCollapse: 'separate',
    borderSpacing: '5px',
    marginLeft: '-5px',
    '& .MuiTableCell-root': {
      border: '0',
      padding: '12px 16px',
      borderRadius: '2px',
      backgroundColor: palette.shades[200],
      textAlign: 'center',
      '&:first-of-type': {
        width: '220px',
        textAlign: 'left'
      },
      '& .billingItemTable': {
        padding: '0',
        margin: '0'
      },
      [breakpointsFunc.breakpoints.down('md')]: {
        padding: '12px'
      }
    },
    '& .MuiTableHead-root': {
      '& .MuiTableCell-root': {
        borderBottom: "2px solid ".concat(palette.shades[400]),
        borderStyle: 'inherit'
      }
    }
  },
  disabledPaper: {
    background: palette.shades[200],
    '& .MuiTypography-root': {
      color: palette.shades[500]
    }
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
    '& img': {
      marginLeft: '4px'
    }
  },
  glAccount: {
    display: 'flex',
    marginTop: '12px',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& > div:first-child': {
      width: '100%'
    }
  },
  glAccountRemove: {
    marginLeft: '8px',
    '& .MuiButton-root': {
      width: '48px',
      height: '48px',
      minWidth: '48px',
      border: '1px solid #b8c4ce'
    }
  },
  glAccountItem: {
    display: 'block !important',
    '& i': {
      display: 'block',
      fontSize: '11px',
      fontStyle: 'normal'
    }
  }
}));
export default useStyles;